import { useState } from "react";
import "./scanModule.scss";
import {
  postPrescriptionTemplate,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { scan } from "../../Context/GlobalData";
import headerimage from "../../assets/images/ascas.svg";
import SinglePatientInfo from "../../Components/Global_Components/common/SinglePatientInfo";
import ReportFormInputWithLabel from "../../Components/Global_Components/form/ReportFormInputWithLabel";
import SelectField from "../../Components/Global_Components/form/SelectField";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";
import { renderReportfield } from "../../utils/templateUtils";

export default function ScanModule(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector((state) => state.counter.patientid);

  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name === "nextappointment") {
      const dateTime = e.target.value.split("T");
      setAppointmentData({
        ...appointmentData,
        date: dateTime[0],
        time: dateTime[1] || "",
        p_uhid: props.patientsData?.p_uhid || "",
        name: `${props.patientsData?.titles || ""} ${props.patientsData?.first_name || ""} ${props.patientsData?.last_name || ""}`,
        status: "Not Visited",
        notes: "Booking Visit",
        patient_id: patientId,
      });
    }
  };

  const getSelectedScanLabel = () => {
    const found = scan.find((s) => s.value === formData.typeOfScan);
    return found ? found.label : formData.typeOfScan;
  };

  const consultantOptions = [
    { label: "Dr. Ashwin", value: "Dr. Ashwin" },
    { label: "Cardiologist", value: "Cardiologist" },
    { label: "Other", value: "Other" },
  ];

  const handlesubmit = () => {
    try {
      if (
        props.patientsData?.id !== "" &&
        props.patientsData?.p_uhid !== "" &&
        /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData?.p_uhid || "").trim())
      ) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById(
            "scanModuleReportWrap"
          ).innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "Scan Module",
            },
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <div id="ScanModule">
      <div className="ScanModule">
        <div className="" style={{ width: "100%", display: "block" }} id="patientInfo1">
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              src={headerimage}
              style={{
                width: "100%",
                margin: "0 auto",
              }}
              alt="Header"
            />
          </div>
          {/* Patient Info - reusable component */}
          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />

          {/* Scan Details Form */}
          <div className="detail">
            <h3>SCAN DETAILS</h3>

            <div className="row">
              <div className="col-md-6">
                <div className="d-flex align-items-center my-2">
                  <SelectField
                    label="Type of Scan"
                    name="typeOfScan"
                    value={formData.typeOfScan}
                    options={scan}
                    onChange={handleChange}
                    placeholder="Select Type of Scan"
                    minWidth="180px"
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="d-flex align-items-center my-2">
                  <SelectField
                    label="Consultant"
                    name="consultant"
                    value={formData.consultant}
                    options={consultantOptions}
                    onChange={handleChange}
                    placeholder="Select Consultant"
                    minWidth="180px"
                  />
                </div>
              </div>
              {formData.consultant === "Other" && (
                <div className="col-md-4">
                  <ReportFormInputWithLabel
                    label="Specify Consultant :"
                    name="consultantOther"
                    value={formData.consultantOther || ""}
                    onChange={handleChange}
                    inputClassName="show"
                    placeholder="Specify consultant name"
                    minWidth="180px"
                  />
                </div>
              )}
            </div>

            <div className="row">
              <div className="col-md-4">
                <ReportFormInputWithLabel
                  label="Scan Date :"
                  name="scanDate"
                  value={formData.scanDate}
                  type="date"
                  onChange={handleChange}
                  inputClassName="show"
                  minWidth="180px"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-2">
                <ReportFormInputWithLabel
                  label="Scan Time :"
                  name="scanTime"
                  value={formData.scanTime}
                  type="time"
                  onChange={handleChange}
                  inputClassName="show"
                  minWidth="180px"
                />
              </div>
            </div>

            <div className="d-flex align-items-start py-2" style={{ gap: "10px" }}>
              <label htmlFor="scanNotes" className="fw-bold" style={{ whiteSpace: "nowrap", paddingTop: "6px", minWidth: "180px" }}>
                Scan Details :
              </label>
              <textarea
                className="Textarea"
                placeholder="Enter scan details, findings, and notes..."
                id="scanNotes"
                name="scanNotes"
                value={formData.scanNotes || ""}
                onChange={handleChange}
                rows="6"
                cols="100"
              />
            </div>
          </div>
        </div>

        <p style={{fontWeight: '600'}}>
          NEXT APPOINTMENT - <input name='nextappointment' onChange={handleChange} type='date' />
        </p>

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>

      {/* Print / Report Section */}
      <div id="prescriptionReport">
        <div id="scanModuleReportWrap">
          <Headers />
          <p className="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div className="nameToAgeContainer" style={{ display: "flex", marginBottom: "10px" }}>
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData?.titles} ${props.patientsData?.first_name} ${props.patientsData?.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData?.p_uhid)}
              {renderReportfield("Gender :", props.patientsData?.gender)}
              {renderReportfield("Age :", props.patientsData?.age)}
            </div>
          </div>

          <div style={{ display: "flex", marginTop: "10px" }}>
            <h4>SCAN DETAILS</h4>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("Type of Scan :", getSelectedScanLabel())}
            {renderReportfield(
              "Consultant :",
              formData.consultant === "Other"
                ? formData.consultantOther || "Other"
                : formData.consultant
            )}
            {renderReportfield("Scan Date :", formData.scanDate)}
            {renderReportfield("Scan Time :", formData.scanTime)}
          </div>

          {formData.scanNotes && (

            <div style={{marginBottom: '5px', display:'flex'}}>
            <div style={{fontWeight: '600', margin: '0 10px 10px 10px'}}>Scan Details:</div>
            <pre style={{margin: '0 10px 10px 10px', fontFamily: 'inherit', whiteSpace: 'pre-wrap'}}>{ formData.scanNotes}</pre>
          </div>
          )}

          <div style={{marginTop: '10px'}}>{renderReportfield('Next Appointment:', appointmentData.date?.split('-').reverse().join('-'))}</div>

          <p className="Dani"></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}